import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableFooter, TablePagination, TableRow } from '@mui/material';
import { blueGrey } from '@mui/material/colors';

export default function ProgramsTablePagination({
	count,
	programsTableSettings,
	handlePageChange,
	handleRowsPerPageChange,
}) {
	return (
		<Table sx={{ position: 'absolute', left: 0, bottom: -4 }}>
			<TableFooter>
				<TableRow>
					<TablePagination
						count={count}
						color='secondary'
						variant='outlined'
						page={programsTableSettings.page - 1}
						onPageChange={handlePageChange}
						rowsPerPage={programsTableSettings.pageSize}
						onRowsPerPageChange={(e) => handleRowsPerPageChange(e, 'pageSize')}
						showFirstButton
						showLastButton
						rowsPerPageOptions={[10, 15, 25, 50, 100]}
						sx={{
							width: '100%',
							color: blueGrey[50],
							backgroundColor: blueGrey[800],
							border: `none`,
							//borderBottomLeftRadius: 32,
							//borderBottomRightRadius: 32,
							'& .MuiTablePagination-selectIcon': {
								color: blueGrey[50],
							},
							'& .MuiTablePagination-root': {
								position: 'sticky',
								bottom: -8,
							},
						}}
					/>
				</TableRow>
			</TableFooter>
		</Table>
	);
}

ProgramsTablePagination.propTypes = {
	programsTableSettings: PropTypes.object.isRequired,
	handlePageChange: PropTypes.func.isRequired,
	handleRowsPerPageChange: PropTypes.func.isRequired,
};
